/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 * 	var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 * 	var variant = event.detail.variant; // Get the variant that was added
 * 	var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 * 	bubbles: true,
 * 	detail: {
 * 		quantity: 1
 * 	}
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 * 	bubbles: true
 * }));
 */


/* Floating account creation elements */
/** @type {HTMLDivElement} */
let headerRegisterPanel = null;

/** @type {HTMLInputElement} */
let b2cRegisterCustomerPassword = null;


/* ################################################################################################################## */
/**
 * If on desktop view and looking at a product page that has two or more tabs under the picture section. Changes which
 * tab is "enabled" along with that tabs content.
 *
 * @param {Number} which - Which button was clicked on.
 */
function toggleActiveTab(which) {
	// get all tabs
	/** @type {NodeListOf<HTMLHeadingElement>} */
	let btns = document.querySelectorAll("h2.card__title.heading.h3");//<h2 class="card__title heading h3 tabs inactive">

	/** @type {Number} */
	let i = 0;

	// set all tabs to inactive
	while (i < btns.length) {
		btns[i].classList.remove("active");
		btns[i].classList.add("inactive");
		i += 1;
	}

	// set the tab that was clicked to active
	btns[which].classList.remove("inactive");
	btns[which].classList.add("active");

	// get all content blocks
	/** @type {NodeListOf<HTMLElement>} */
	let contents = document.querySelectorAll(".product-content.rte.text--pull");
	i = 0;

	// set all content blocks to inactive
	while (i < contents.length) {
		contents[i].classList.remove("active");
		contents[i].classList.add("inactive");
		i += 1;
	}

	// set the content block for the tab that was clicked to active
	contents[which].classList.remove("inactive");
	contents[which].classList.add("active");
}


/* ################################################################################################################## */
/**
 * Updates the height of "Create my account" popup to match new height of account creation form that changes based on
 * the text of the password helper message
 *
 * @param {KeyboardEvent} e - The event data for the key-up event.
 */
function onCreateAccountPasswordFieldKeyup(e) {
	headerRegisterPanel.parentElement.style.height = window.getComputedStyle(headerRegisterPanel).height;
}


/* ################################################################################################################## */
/**
 * Resizes the popup for the sign-in/create account if the window changes height
 *
 * @param {Event} e - The event data for the window Resize event.
 */
function onDesktopWindowResize(e) {
	/** @type {HTMLElement} */
	let accountPopover = document.getElementById("account-popover");

	if (accountPopover.getAttribute("aria-hidden") === "false") {
		/** @type {HTMLDivElement} */
		let panelList = document.querySelector("div.popover__panel-list");
		
		/** @type {HTMLElement} */
		let activePanel = panelList.querySelector(".is-selected");
		panelList.style.height = activePanel.clientHeight + "px";
	}
}


/* ################################################################################################################## */
/**
 * When the DOM has been rendered, perform several actions.
 *
 * @param {Event} e - The event data for the DOMContentLoaded event.
 */
function onHtmlRendered(e) {
	document.removeEventListener("DOMContentLoaded", onHtmlRendered);
	
	// get the dropdown menu and add keyup event listener to password field of account creation if the field is present (not signed in)
	headerRegisterPanel = document.getElementById("header-register-panel");
	b2cRegisterCustomerPassword = document.getElementById("b2c_register_customer_password");
	if (b2cRegisterCustomerPassword !== null) b2cRegisterCustomerPassword.addEventListener("keyup", onCreateAccountPasswordFieldKeyup);
	
	// if the website is being viewed on a desktop, add a browser window resize listener for dealing with the mini-account popup
	if (document.documentElement.classList.contains("desktop")) {
		window.addEventListener("resize", onDesktopWindowResize);
	}
}

document.addEventListener("DOMContentLoaded", onHtmlRendered);